
export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Start',
        to: '/dashboard',
        icon: 'cil-speedometer',
        badge: {
          color: '',
          text: ''
        }
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Zamówienia',
        to: '/b2borders',
        icon: 'cil-pencil',
        badge: {
          color: '',
          text: ''
        }
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Produkty',
        to: '/b2bproducts',
        icon: 'cil-pencil',
        badge: {
          color: '',
          text: ''
        }
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Użytkownicy',
        to: '/b2busers',
        icon: 'cil-pencil',
        badge: {
          color: '',
          text: ''
        }
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Lokalizacja',
        to: '/b2blocalisation',
        icon: 'cil-pencil',
        badge: {
          color: '',
          text: ''
        }
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Handlowcy',
        to: '/b2bsalesrepresentatives',
        icon: 'cil-pencil',
        badge: {
          color: '',
          text: ''
        }
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Stary panel',
        to: '/b2bgotooldpanel',
        icon: 'cil-pencil',
        badge: {
          color: '',
          text: ''
        }
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Enova',
        to: '/b2bgotoenova',
        icon: 'cil-pencil',
        badge: {
          color: '',
          text: ''
        }
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Import cen zakupu',
        to: '/b2bbuypricesimport',
        icon: 'cil-pencil',
        badge: {
          color: '',
          text: ''
        }
      },
    ]
  }
]